module.exports = __webpack_public_path__ + "static/media/mask-group-1@2x.ead5dd60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mask-group-1@2x.png
// module id = 586
// module chunks = 1